(() => {
  'use strict';
  function init(scope = document) {
    scope.querySelectorAll('[data-uv-ready-product]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      const add = root.querySelector('[data-uv-add]');
      const quantity = form.elements.quantity;
      const variant = root.querySelector('[data-uv-variant]');
      let available = !add.disabled;
      let pending = false;
      root.querySelectorAll('[data-uv-quantity]').forEach(button => button.addEventListener('click', () => {
        quantity.value = Math.max(1, (parseInt(quantity.value, 10) || 1) + Number(button.dataset.uvQuantity));
        quantity.dispatchEvent(new Event('change', {bubbles:true}));
      }));
      variant?.addEventListener('change', () => {
        const option = variant.selectedOptions[0];
        available = option.dataset.available === 'true';
        add.disabled = !available || pending;
        add.textContent = available ? 'Add to cart' : 'Sold out';
        root.querySelector('[data-uv-price]').textContent = option.dataset.price;
        root.querySelector('[data-uv-sticky-price]').textContent = option.dataset.price;
        const compare = root.querySelector('[data-uv-compare]');
        compare.hidden = !option.dataset.compare;
        compare.textContent = option.dataset.compare;
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState(null, '', url);
      });
      root.querySelectorAll('[data-uv-image]').forEach(button => button.addEventListener('click', () => {
        const image = root.querySelector('.s2t-uv-ready__image');
        image.removeAttribute('srcset');
        image.src = button.dataset.uvImage;
        image.alt = button.dataset.uvAlt;
        root.querySelectorAll('[data-uv-image]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      }));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (pending || !available || !form.reportValidity()) return;
        pending = true;
        add.disabled = true;
        add.textContent = 'Adding…';
        const status = root.querySelector('[data-uv-status]');
        const cartLink = root.querySelector('[data-uv-cart-link]');
        status.hidden = true;
        cartLink.hidden = true;
        status.dataset.error = 'false';
        try {
          const response = await fetch(root.dataset.addUrl, {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'This item could not be added. Please check its availability.');
          status.textContent = 'Added to your cart.';
          status.hidden = false;
          cartLink.hidden = false;
          // Refresh the existing cart integration; native cart page remains the fallback.
          try {
            if (typeof window.upcartRefreshCart === 'function') await window.upcartRefreshCart();
            if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
            else window.location.assign(root.dataset.cartUrl);
          } catch (_) { window.location.assign(root.dataset.cartUrl); }
        } catch (error) {
          status.textContent = error instanceof TypeError ? 'We could not confirm the cart update. Check your cart before trying again.' : error.message;
          status.dataset.error = 'true';
          status.hidden = false;
          cartLink.hidden = false;
        } finally {
          pending = false;
          add.disabled = !available;
          add.textContent = available ? 'Add to cart' : 'Sold out';
        }
      });
      const sticky = root.querySelector('[data-uv-sticky]');
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;}, {threshold:0});
        observer.observe(form);
        root._uvObserver = observer;
      }
      sticky.querySelector('a').addEventListener('click', event => {
        event.preventDefault();
        root.querySelector('.s2t-uv-ready__order').scrollIntoView({block:'start', behavior:'auto'});
        quantity.focus({preventScroll:true});
      });
    });
    scope.querySelectorAll('[data-uv-carousel]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const rail = root.querySelector('[role=list]');
      const previous = root.querySelector('[data-uv-scroll="-1"]');
      const next = root.querySelector('[data-uv-scroll="1"]');
      const update = () => {
        previous.disabled = rail.scrollLeft < 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      };
      root.querySelectorAll('[data-uv-scroll]').forEach(button => button.addEventListener('click', () => {
        const card = rail.firstElementChild;
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 16;
        rail.scrollBy({left:Number(button.dataset.uvScroll) * (card.getBoundingClientRect().width + gap), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
      rail.addEventListener('scroll', update, {passive:true});
      if ('ResizeObserver' in window) {root._uvResize = new ResizeObserver(update);root._uvResize.observe(rail);}
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-uv-ready-product],[data-uv-carousel]').forEach(root => {root._uvObserver?.disconnect();root._uvResize?.disconnect();});
  });
})();
